import React, {lazy, memo, Suspense, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {useNavContext, useNavUpdaterContext} from '../NavContextProvider';

const AppSearchModal = createPreloadableLazyComponent(
  () => import('./AppSearchModal')
).Component;

const AppSearchComp = () => {
  const {searchActive} = useNavContext();
  const {deactivateSearch} = useNavUpdaterContext();
  const location = useLocation();

  // Clear the launcher and hide it whenever the route changes.
  useEffect(() => {
    deactivateSearch();
  }, [deactivateSearch, location.pathname]);

  if (!searchActive) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <AppSearchModal onClose={deactivateSearch} />
    </Suspense>
  );
};

export const AppSearch = memo(AppSearchComp);
